import { render } from "./FullScreenLoading.vue?vue&type=template&id=706de4b0&ts=true"
import script from "./FullScreenLoading.ts?vue&type=script&lang=ts&external"
export * from "./FullScreenLoading.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__